import axios from 'axios'
import API from '@/common/api'
import store from '..'

export default {
  namespaced: true,
  state: {
    thirdparty: null
  },
  mutations: {
  },
  actions: {
    async getThirdparty ({ dispatch, state }) {
      const file = 'thirdparty/thirdparty.json'
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        state.thirdparty = res.data.message
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    async getAccessToken ({ dispatch, state }, sns) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=sc-sns-feed&func=get-access-token&siteid=${API.SITE_INFO.site}&sns=${sns}`)
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    async getInstagramFeed ({ state }, data) {
      try {
        const res = await axios.get(`https://graph.instagram.com/me/media?fields=id,media_type,media_url,thumbnail_url,caption,timestamp,permalink&access_token=${data.accessToken}`)
        return res.data
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    getThirdparty: state => state.thirdparty
  }
}
